export type GtmPageKey = 'srp' | 'vdp';

const SPA_TRACKED_SEGMENTS = new Set(['cars', 'vehicle']);

export default function emitGtmSpaPageview(
  previousSegment: string,
  currentSegment: string,
  fullPath: string,
  previousFullPath: string
) {
  const isTrackedTransition =
    previousSegment !== currentSegment &&
    SPA_TRACKED_SEGMENTS.has(previousSegment) &&
    SPA_TRACKED_SEGMENTS.has(currentSegment);

  if (!isTrackedTransition) {
    return;
  }

  const pageKey: GtmPageKey = currentSegment === 'vehicle' ? 'vdp' : 'srp';
  const previousUrl = window.location.origin + previousFullPath;

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: 'spaRouteChange',
    pageKey,
    path: fullPath,
    previousUrl
  });
}
